$(document).ready(() => {
  function setUrl() {
    const currentSlide = $(".blog .carousel__item.slick-current");
    const carouselButton = $(".blog .carousel__button");
    const carouselButtonLabel = $(".blog #carousel__button-label");
    carouselButton.attr("href", currentSlide.data("url"));
    if (carouselButtonLabel.length !== 0) {
      carouselButtonLabel[0].textContent = currentSlide.data("buttonLabel");
    }
  }
  $(".blog .carousel__slider").slick({
    infinite: true,
    dots: true,
    prevArrow: false,
    nextArrow: false,
  });
  $(".blog .carousel__slider").on("afterChange", () => {
    setUrl();
  });
  setUrl();

  $(".home .carousel__slider").slick({
    lazyLoad: "progressive",
    autoplay: false,
    autoplaySpeed: 8000,
    infinite: true,
    dots: true,
    prevArrow: false,
    nextArrow: false,
  });
  $(".home.carousel .slick-dots").addClass("white");

  $(".home .carousel__slider").on(
    "beforeChange",
    (event, slick, currentSlide, nextSlide) => {
      if (nextSlide !== 0) {
        $(".home.carousel .slick-dots").removeClass("white");
      } else {
        $(".home.carousel .slick-dots").addClass("white");
      }

      if (nextSlide === 0 || nextSlide === 1 || nextSlide === 2 || nextSlide === 3 || nextSlide === 8) {
        $(".marquee-text-1").css("display", "none");
        $(".marquee-text-2").css("display", "none");
        $(".marquee-text-3").css("display", "inline-flex");
        $(".marquee-text-4").css("display", "none");
        $(".marquee-text-5").css("display", "none");
        $(".marquee-text-6").css("display", "none");
        $(".carousel__marquee-arrow").css("opacity", "0");
        $(".carousel__marquee").css("opacity", "0");
      } else if (nextSlide === 4) {
        $(".marquee-text-1").css("display", "none");
        $(".marquee-text-2").css("display", "none");
        $(".marquee-text-3").css("display", "inline-flex");
        $(".marquee-text-4").css("display", "none");
        $(".marquee-text-5").css("display", "none");
        $(".marquee-text-6").css("display", "none");
        $(".carousel__marquee-arrow").css("opacity", "1");
        $(".carousel__marquee").css("opacity", "1");
      } else if (nextSlide === 5) {
        $(".marquee-text-1").css("display", "none");
        $(".marquee-text-2").css("display", "inline-flex");
        $(".marquee-text-3").css("display", "none");
        $(".marquee-text-4").css("display", "none");
        $(".marquee-text-5").css("display", "none");
        $(".marquee-text-6").css("display", "none");
        $(".carousel__marquee-arrow").css("opacity", "1");
        $(".carousel__marquee").css("opacity", "1");
      } else if (nextSlide === 6) {
        $(".marquee-text-1").css("display", "none");
        $(".marquee-text-2").css("display", "inline-flex");
        $(".marquee-text-3").css("display", "none");
        $(".marquee-text-4").css("display", "none");
        $(".marquee-text-5").css("display", "none");
        $(".marquee-text-6").css("display", "none");
        $(".carousel__marquee-arrow").css("opacity", "1");
        $(".carousel__marquee").css("opacity", "1");
      } else {
        $(".marquee-text-1").css("display", "inline-flex");
        $(".marquee-text-2").css("display", "none");
        $(".marquee-text-3").css("display", "none");
        $(".marquee-text-4").css("display", "none");
        $(".marquee-text-5").css("display", "none");
        $(".marquee-text-6").css("display", "none");
        $(".carousel__marquee-arrow").css("opacity", "1");
        $(".carousel__marquee").css("opacity", "1");
      }
      switch (nextSlide) {
        case 0:
          $(".carousel__marquee-wrapper").css("background", "#FFF0");
          $(".carousel__marquee-wrapper").css("opacity", "0");
          break;
        case 1:
          $(".carousel__marquee-wrapper").css("background", "#FFF0");
          $(".carousel__marquee-wrapper").css("opacity", "0");
          break;
        case 2:
          $(".carousel__marquee-wrapper").css("background", "#FFF0");
          $(".carousel__marquee-wrapper").css("opacity", "0");
          break;
        case 3:
          $(".carousel__marquee-wrapper").css("background", "#FFF0");
          $(".carousel__marquee-wrapper").css("opacity", "0");
          break;
        case 4:
          $(".carousel__marquee-wrapper").css("background", "#718EA8");
          $(".carousel__marquee-wrapper").css("opacity", "1");
          break;
        case 5:
          $(".carousel__marquee-wrapper").css("background", "#E8708C");
          $(".carousel__marquee-wrapper").css("opacity", "1");
          break;
        case 6:
          $(".carousel__marquee-wrapper").css("background", "#9794E7");
          $(".carousel__marquee-wrapper").css("opacity", "1");
          break;
        case 7:
          $(".carousel__marquee-wrapper").css("background", "#68647B");
          $(".carousel__marquee-wrapper").css("opacity", "1");
          break;
        case 8:
          $(".carousel__marquee-wrapper").css("background", "#FFF0");
          $(".carousel__marquee-wrapper").css("opacity", "0");
          break;
        case 9:
          $(".carousel__marquee-wrapper").css("background", "#FFF0");
          $(".carousel__marquee-wrapper").css("opacity", "0");
          break;
      }
    }
  );
});
